export default __webpack_public_path__ + "e2d986b45025f3f18506ef9a573b9c08.png";